<header class="app-header">
    <a class="brand" routerLink="/">
        <span class="brand-mark">I</span>
        <span>Imaš Termin</span>
    </a>

    <nav class="auth-nav">
        @if (!auth.ready) {
            <span class="auth-loading">Učitavam…</span>
        } @else if (!isLoggedIn) {
            <button mat-flat-button color="primary" (click)="login()">
                Prijava
            </button>

            <button mat-stroked-button color="primary" routerLink="/registration">
                Registracija
            </button>
        } @else {
            @if (userLabel) {
                <span class="user-label">👤 {{ userLabel }}</span>
            }

            <button class="dashboard-button" mat-flat-button color="primary" (click)="goToDashboard()">
                {{ dashboardLabel }}
            </button>

            <button class="logout-button" mat-stroked-button color="primary" (click)="logout()" aria-label="Odjava">
                <mat-icon aria-hidden="true">logout</mat-icon>
                <span>Odjava</span>
            </button>
        }
    </nav>
</header>
